import React, { useState, useEffect, useRef } from "react";
import "./ListCompanies.scss";
import "../DashBoard/sliding.css";
import userImg from '../../images/user.png';

import axios from "axios";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { sidebarReducer } from "../../Redux/store";
// import { userReducer } from "../../Redux/store";

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import SearchBarComponent from "../../components/searchBar/searchBarComponent"
import {
  SuccessAlert,
  FailureAlert,
  InformationAlert,
  SuccessUpdate,
  FailureUpdate,
  SuccessDelete,
} from "../../components/Alert_msg/alert_msg";
// import ListPermissions from "../ListPermissions/ListPermissions";

function ListCompanies() {
  // Dispatch function
  const dispatch = useDispatch();

  //API related selectors
  const token = useSelector((state) => state.AccessTocken.accessTocken);

  //Permission for Roles
  const Add_Permission = useSelector(
    (state) => state.AccessTocken.Add_Permission
  );
  const Edit_Permission = useSelector(
    (state) => state.AccessTocken.Edit_Permission
  );
  const Delete_Permission = useSelector(
    (state) => state.AccessTocken.Delete_Permission
  );
  const View_Permission = useSelector(
    (state) => state.AccessTocken.View_Permission
  );
  
  const user_edit = useSelector((state) => state.user.user_edit);
  const [userData, setUserData] = useState([]);


  const [userValidated, setUserValidated] = useState(false);
  const apiLoad = useSelector((state) => state.sidebar.apiLoad);
  const [isOpen, setIsOpen] = useState(false);
  const [isDeleteOpen, setDeleteOpen] = useState(false);

  const openPopup = () => {
      setIsOpen(true);
  };

  const closePopup = () => {
    setIsOpen(false);
    getSelectedUser(null);
  };

  const closeUpdateUserPopup =()=>{
    setIsOpen(false);
    getSelectedUser(null);
    setUserData([])
    getUsersList();
  }

  const [isPermissionOpen, setIsPermissionOpen] = useState(false);
  const [selectedUser, getSelectedUser] = useState(null);

  const openPermissionPopup = () => {
    setIsPermissionOpen(true);
  };

  const closePermissionPopup = () => {
    setIsPermissionOpen(false);
  };


  //Header for API's
  const options = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const listLimit = useSelector((state) => state.AccessTocken.recordsPerPage);

  // division response for Division Dropdown


  async function getUsersList() {
    dispatch(sidebarReducer.apiLoad(true));
    // setApiLaod(true);
    await axios
    
    .get("rolepermission/allUsersForSpecificCompany/"+JSON.parse(sessionStorage.getItem("userdata")).te_companyid)
      // .get("userProfile/getAllUsers")
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          //setApiLaod(false);
          // console.log("getAllUsers2", response.data.length)
          setUserData(response.data.result[0].response);
        } else if (response.status !== 200) {
          dispatch(sidebarReducer.stringUpdate("AppDown"));
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.stringUpdate("AppDown"));
      });
  }
  var addnameColor = "black";

  if (userValidated) {
    addnameColor = "green";
  } else {
    addnameColor = "red";
  }
  // useEffect(() => {
  //   if (View_Permission === 1) {
  //     // responseData();
  //     getUsersList
  //   }
  //   return () => {
  //     console.log("resp in return");
  //   };
  //   // eslint-disable-next-line
  // }, [View_Permission]);
  useEffect(() => {
  
    getUsersList();
  }, []);


  //Table and slidingpane width
  const ref = useRef(null);


  const onEdit = (user) => {
    console.log("selected User", user);
    getSelectedUser(user);
    setIsOpen(true);
  };

  const onDelete = (user) => {
    getSelectedUser(user);
    setDeleteOpen(true);
  }

  const closeDeletePopup = () => {
    setDeleteOpen(false);
  }
  const DeleteSelecteUser = (user) => {
    console.log("delete selected", user);
    // setDeleteOpen(false);
    DeleteUser(user)
  }
  async function DeleteUser(user) {
    dispatch(sidebarReducer.apiLoad(true));
    // setApiLaod(true);
    await axios
      .delete("/userProfile/delete/" + user.te_userid)
      .then((response) => {
        if (response.status === 200) {
          dispatch(sidebarReducer.apiLoad(false));
          //setApiLaod(false);
          toast.success('User Deleted Successfully', {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setDeleteOpen(false);
          getUsersList();
          
          // setUserCount(response.data.length);
          // let pages;
          // response.data.data.count === 0
          //   ? (pages = 1)
          //   : (pages = Math.ceil(response.data.data.count / listLimit));
          // setNoOfPages(pages);
        } else if (response.status !== 200) {
          toast.error('User Deletion Unsuccessfull', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          setDeleteOpen(false);
          getUsersList();
          
        }
      })
      .catch((err) => {
        dispatch(sidebarReducer.apiLoad(false));

      });
  }

  return (
    <div className="list-users">
       <ToastContainer closeButton={false}/>
      {
        // console.log("entered user")
      }
      {/* {View_Permission === 1 ? ( */}
      <div className="container-fluid">
        <div className="title-section">
        <div>
        <p>Company List</p>
        </div>
        <SearchBarComponent className="search-bar-div"/>
       
          <div >
            {/* <button type="button" onClick={() => {openPopup();}}>
              <span >Create User</span>
            </button> */}



          </div>
       </div>
       
       
       <div>
          {/* Toggle swich */}
         
          <div className="row ">
            <div className="col ">
              <div className="container-fluid g-0">
                <div
                  className="table-wrapper-scroll-y user-list-table"
                >
                  {apiLoad ? (
                    <div
                      style={{
                        height: "80vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <div className="spinnerApi"></div>
                    </div>
                  ) : (
                    <>
                      <div style={{ display: 'flex', flexWrap: 'wrap',overflowY:"auto",height:"68vh" }}>
      {userData && Array.isArray(userData) && userData.map((item, index) => (
        <div
          key={index}
          style={{
            width: '320px',
            height: 'auto',
            display: 'flex',
            border: 'none',
            overflow: 'hidden',
            backgroundColor: '#FFFFFF',
            borderRadius: '10px',
            padding: '20px',
            margin: '20px',
          }}
        >
          {/* <div style={{ width: '40%' }}> */}
          <div style={{textAlign:"center"}}>
            <img
              style={{ width: '76px', height: '76px', objectFit: 'cover' }}
              src={userImg}
              alt="Profile Image"
            />
             <p style={{ margin: '5px 0' }}>{item.te_username}{" "}</p>
          </div>
          <div
            style={{
              flex: 1,
              paddingLeft: '15px', 
              fontSize: '15px',
            }}
          >
            
            <p style={{ margin: '5px 0' }}>{item.te_firstname} {item.te_middlename} {item.te_lastname}</p>
            <p style={{ margin: '5px 0' }}> {item.te_useremail ? item.te_useremail:"N/A"}</p>
            <p style={{ margin: '5px 0' }}> {item.te_mobileno ? item.te_mobileno : "N/A"}</p>
           
            <p style={{ margin: '5px 0' }}>   {item.te_role_name ? item.te_role_name : "N/A"}</p>
          </div>
        </div>
      ))}
    </div>
                       
                      
                    </>
                  )}
                </div>

              </div>
            </div>
          </div>
        </div>
        {/* add role  end */}

        <SuccessAlert />
        <FailureAlert />
        <InformationAlert />
        <SuccessUpdate />
        <FailureUpdate />
        <SuccessDelete />
      </div>
     

    </div>
  );
}

export default ListCompanies;
